import _toConsumableArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export default (function (sources) {
  return sources.reduce(function (acc, item) {
    var duplicatedSource = acc.find(function (s) {
      return s.height === item.height && s.width === item.width;
    });
    var isDuplicatedSourceOriginal = duplicatedSource === null || duplicatedSource === void 0 ? void 0 : duplicatedSource.isOriginal;
    return isDuplicatedSourceOriginal ? [].concat(_toConsumableArray(acc.filter(function (s) {
      return !s.isOriginal;
    })), [item]) : duplicatedSource ? acc : [].concat(_toConsumableArray(acc), [item]);
  }, []);
});